export enum TRANSFER_APPOINTMENT_STATUS {
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    CREATED = 'CREATED',
    SCHEDULES_ASSIGNED = 'SCHEDULES_ASSIGNED'
}

export const ACTIONS_AVAILABLE_STATUS = ["CANCELED", "ENDED"]

export enum TRANSFER_APPOINTMENT_WAYS {
    ONEWAY = "ONEWAY",
    RETURNTRIP = "RETURNTRIP"
}